var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfferLetter = function SvgOfferLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#offerLetter_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.332,
    y: 0.5,
    fill: "#EBF3FF",
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#offerLetter_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#offerLetter_svg__c)",
    d: "M33.734 53.315q-7.103.369-14.206 0c-3.652-.21-6.843-3.6-7.005-7.343a273 273 0 0 1 0-20.944c.163-3.744 3.354-7.133 7.006-7.344q4.92-.256 9.84-.157c.651.013 1.28.309 1.75.817 2.93 3.171 5.956 6.38 8.988 9.487.478.49.756 1.131.77 1.79q.176 8.175-.138 16.35c-.162 3.744-3.352 7.132-7.005 7.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#346FCF",
    fillOpacity: 0.52,
    d: "m40.898 36.224-10.439-7.932 4.987-6.367c1.567 1.88 4.514 5.74 4.825 6.075.37.402.595 1.145.62 1.467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6C5FA",
    d: "M30.84 17.82c3.569 2.92 6.82 6.296 9.568 10.4.515.562.129 1.483-.623 1.483H32.6c-1.917 0-3.471-1.596-3.471-3.564v-7.62c0-.92 1.095-1.367 1.71-.698"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.259,
    height: 2.247,
    x: 19.742,
    y: 31.1,
    fill: "#A6C5FA",
    rx: 1.123
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 2.247,
    x: 19.742,
    y: 35.821,
    fill: "#A6C5FA",
    rx: 1.123
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.23,
    height: 2.247,
    x: 19.742,
    y: 40.541,
    fill: "#A6C5FA",
    rx: 1.123
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF0DD",
    d: "m14.639 30.303 1.277-.507c.901-.356 1.92-.013 2.447.828l.748 1.19a2.07 2.07 0 0 0 1.183.895l1.32.372c.931.261 1.56 1.166 1.512 2.167l-.07 1.42c-.024.524.137 1.04.451 1.447l.857 1.108a2.206 2.206 0 0 1 0 2.681l-.857 1.109c-.314.41-.475.923-.45 1.446l.07 1.42c.047 1.002-.582 1.906-1.514 2.168l-1.32.371a2.04 2.04 0 0 0-1.182.895l-.748 1.19c-.526.842-1.546 1.185-2.447.83l-1.277-.508a1.99 1.99 0 0 0-1.462 0l-1.277.507c-.902.356-1.921.013-2.448-.828l-.747-1.191a2.07 2.07 0 0 0-1.183-.895l-1.32-.371c-.932-.262-1.56-1.166-1.512-2.167l.07-1.421a2.2 2.2 0 0 0-.452-1.446l-.856-1.109a2.206 2.206 0 0 1 0-2.68l.856-1.11c.315-.409.475-.922.451-1.445l-.07-1.42c-.048-1.002.581-1.907 1.513-2.168l1.32-.372a2.04 2.04 0 0 0 1.183-.894l.747-1.19c.527-.842 1.546-1.185 2.448-.83l1.277.508c.47.186.99.186 1.462 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#offerLetter_svg__d)",
    d: "m14.543 31.63 1.112-.441c.785-.31 1.673-.011 2.131.721l.65 1.037c.24.381.607.658 1.031.779l1.149.323c.811.228 1.359 1.015 1.317 1.887l-.06 1.237c-.022.455.118.905.392 1.259l.745.965a1.92 1.92 0 0 1 0 2.334l-.745.965a1.92 1.92 0 0 0-.393 1.26l.06 1.236c.043.872-.505 1.66-1.316 1.887l-1.149.324c-.424.118-.79.395-1.03.779l-.65 1.036a1.75 1.75 0 0 1-2.132.722l-1.112-.442a1.73 1.73 0 0 0-1.272 0l-1.112.442a1.75 1.75 0 0 1-2.131-.722l-.651-1.036a1.8 1.8 0 0 0-1.03-.78l-1.149-.323c-.811-.227-1.36-1.015-1.317-1.887l.06-1.237a1.92 1.92 0 0 0-.392-1.258l-.746-.966a1.92 1.92 0 0 1 0-2.334l.746-.965c.274-.357.414-.804.392-1.259l-.06-1.237c-.042-.872.506-1.66 1.317-1.887l1.149-.323a1.78 1.78 0 0 0 1.03-.78l.65-1.036c.459-.732 1.347-1.031 2.132-.721l1.112.441c.408.162.861.162 1.272 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F7A49",
    fillRule: "evenodd",
    d: "M18.224 37.071c.481.495.481 1.296 0 1.791l-5.054 5.197c-.481.495-1.26.495-1.742 0l-2.653-2.728a1.29 1.29 0 0 1 0-1.791 1.21 1.21 0 0 1 1.741 0l1.783 1.833 4.184-4.302a1.21 1.21 0 0 1 1.741 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "offerLetter_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.1646 32.60299 -29.00822 -21.50023 38.763 19.843)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "offerLetter_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.348 0 0 8.84529 13.947 40.565)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "offerLetter_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.332,
    y: 0.5,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "offerLetter_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.322 17.5h28.676v36H12.322z"
  })))));
};
export default SvgOfferLetter;